export const TimeConstants = Object.freeze({
  defaultBackTime: 7, //days
})

export const DEFAULT_DEBOUNCE_TIME = 1000 //mls
